import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch, AiOutlineBarChart } from "react-icons/ai";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title as ChartTitle,
    Tooltip as ChartTooltip,
    Legend as ChartLegend,
} from 'chart.js';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import '../css/reports-v2.css'
import '../css/dashboard.css'
import { getValueCookie } from '../services/cookieService';
import { getInformationWithData, getInformationWithDataDashboard } from '../services/CABE';
import { DeleteCharactersNotAccepted, ItemDesc, MonthInLetters, NumberFormat, OrderArray } from '../functions/generalFunctions';
import { getIndexElement } from '../functions/searchInObject'
import { pricesFormat } from '../functions/pricesFormat';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from '../components/LoadingWindow';
import ExcelDocument from '../components/ExcelDocument';
import { getDataSet, getDataSetShorts } from '../functions/generateDataSetExcel';
import ModalOrders from '../components/ModalComponent';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLines } from '../functions/dateFormat';
import { confirmCloseAlert } from '../functions/alerts';
import { Menu } from '../components/Menu/Menu';

// Same palette used by getSalesPerRouteAllYear() / BarSalesDasboard (AdminLobbyV2's
// "Graphs of Sales") — reused here so this chart matches the rest of the dashboards.
const PRODUCT_LINE_COLORS = [
    'rgba(37,  99,  235, 0.82)',
    'rgba(16,  185, 129, 0.82)',
    'rgba(245, 158, 11,  0.82)',
    'rgba(139, 92,  246, 0.82)',
    'rgba(239, 68,  68,  0.82)',
    'rgba(6,   182, 212, 0.82)',
    'rgba(249, 115, 22,  0.82)',
    'rgba(20,  184, 166, 0.82)',
    'rgba(99,  102, 241, 0.82)',
    'rgba(236, 72,  153, 0.82)',
    'rgba(132, 204, 22,  0.82)',
    'rgba(234, 179, 8,   0.82)'
];
export default class Shorts extends Component {
    constructor(props) {
        super(props)
        this.BarGraph1 = React.createRef()
        this.ModalLoading = React.createRef();
        this.ProductLineChartRef = React.createRef();
        ChartJS.register(CategoryScale, LinearScale, BarElement, ChartTitle, ChartTooltip, ChartLegend);

    }



    state = {
        HeaderTable: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        Body: [],
        BodyFilter: [],
        AllInformation: [],
        Totals: [],
        showModal1: false,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        AllNoProccessInformation: [],
        ShortDetail: [],
        ShortDetailWithTotal: [],
        CheckFilters: [],
        CheckFiltersSeller: [],
        SearchText: '',
        flag: true,

        // Shorts by Product Line (bar chart)
        ShortsByProductLine: [],
        ProductLineChartLoading: false,
        ProductLineChartError: null,

        // Product line detail modal (opened by clicking a bar)
        showProductLineModal: false,
        ProductLineModalTitle: '',
        ProductLineModalData: [],
        ProductLineModalLoading: false,
        ProductLineModalError: null,

        // Items grouped by Product Line (table)
        ItemsByProductLine: [],
        ItemsByProductLineLoading: false,
        ItemsByProductLineError: null

    }

    componentDidMount() {

    }

    TableHeader(splitStartDate, splitEndDate) {
        let years = [{ year: '', span: 4 }]
        let months = []
        let General = [{ year: '', month: '', title: ['   #   ', 'Item Code', 'Product Line', 'Description'] }]

        for (let a = Number(splitStartDate[0]); a <= Number(splitEndDate[0]); a++) {
            if (a === Number(splitStartDate[0]) && a === Number(splitEndDate[0])) {
                var cont1 = 0
                for (let b = Number(splitStartDate[1]); b <= Number(splitEndDate[1]); b++) {
                    cont1++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Short', '', 'Short ($)'] }])
                }
                const temp = {
                    year: String(a),
                    span: cont1 * 3
                }
                years.push(temp)
                break
            } else if (a === Number(splitStartDate[0])) {
                var cont2 = 0
                for (let b = Number(splitStartDate[1]); b <= 12; b++) {
                    cont2++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Short', '', 'Short ($)'] }])
                }

                const temp = {
                    year: String(a),
                    span: cont2 * 3
                }
                years.push(temp)

            } else if (a === Number(splitEndDate[0])) {
                var cont3 = 0
                for (let b = 1; b <= Number(splitEndDate[1]); b++) {
                    cont3++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Short', '', 'Short ($)'] }])
                }

                const temp = {
                    year: String(a),
                    span: cont3 * 3
                }
                years.push(temp)

            } else {

                for (let b = 1; b <= 12; b++) {

                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Short', '', 'Short ($)'] }])
                }

                const temp = {
                    year: String(a),
                    span: 12 * 3
                }
                years.push(temp)
            }

        }

        this.setState({
            HeaderTable: {
                Row1: years,
                Row2: months,
                Row3: General
            }
        })

        return
    }
    clearAll() {
        this.setState({
            HeaderTable: {
                Row1: [],
                Row2: [],
                Row3: []
            },
            Body: [],
            BodyFilter: [],
            AllInformation: [],
            Totals: [],
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: ''
            },
            AllNoProccessInformation: [],
            ShortDetail: [],
            ShortsByProductLine: [],
            ItemsByProductLine: [],
        })
    }

    async getShorts() {
        this.ModalLoading.current.showState(true);
        this.clearAll()
        var date1 = document.getElementById('startShortFilterDate').value
        var date2 = document.getElementById('endShortFilterDate').value
        const splitStartDate = date1.split('-')
        const splitEndDate = date2.split('-')
        if (splitStartDate.length === 3 && splitEndDate.length === 3) {
            this.TableHeader(splitStartDate, splitEndDate)
            const data = {
                Start: date1,
                End: date2,
            }

            // Fire the two new report sections in parallel with the main table load —
            // they're independent and shouldn't block/be blocked by each other.
            this.getShortsByProductLine(data)
            this.getItemsByProductLine(data)

            const result = await getInformationWithDataDashboard('/invoice/report/shortsV2', data)

            let temporal = []
            let filters = []
            let filtersSeller = []
            if (result.status.code === 1) {




                for (const item of result.data) {
                    let newMonth=item.InvoiceDate ? item.InvoiceDate.split('-') : []
                    if(newMonth.length===3){
                        item.Month=MonthInLetters(newMonth[1])
                    }else{
                        item.Month=''
                    }

                    // getIndexElement requires a string third argument (it bails to -1 otherwise),
                    // and item.Seller isn't guaranteed to be a string like UDF_RUTA is — coerce it
                    // so items with a null/undefined/numeric Seller dedupe into one pill instead of
                    // creating a new "filter" entry (and disappearing from the AND-filter) per row.
                    item.Seller = String(item.Seller === null  ||  item.Seller === undefined ?  '' : item.Seller)

                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    const indexFilter = getIndexElement(filters, 'Route', item.UDF_RUTA)
                    const indexFilterSeller = getIndexElement(filtersSeller, 'Seller', item.Seller)


                    if (indexFilter === -1) {
                        filters.push({ Route: item.UDF_RUTA, check: true })
                    }

                    if (indexFilterSeller === -1) {
                        filtersSeller.push({ Seller: item.Seller, check: true })
                    }



                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []

                    if (index === -1 && splitDate.length === 3) {

                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: Number(item.shorts),
                            SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                            PurchaseCost: Number(item.UnitCost),
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: Number(item.shorts),
                                SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                                PurchaseCost: Number(item.UnitCost),
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: Number(item.shorts),
                                    SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                                    PurchaseCost: Number(item.UnitCost),
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS 
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += Number(item.shorts)
                                element3.SalesPrice += (Number(item.UnitPrice) * Number(item.shorts))
                                element3.PurchaseCost += Number(item.UnitCost)
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }

                    }
                }
                this.setState({ AllInformation: result.data })
                for (const month of this.state.HeaderTable.Row2) {
                    for (const item of temporal) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-',
                                    SalesPrice: '-',
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: '-',
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-',
                                    SalesPrice: '-',
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: '-',
                                }
                                temporal.Months.push(add2)
                                item.Detail[indexyear] = temporal
                            }
                        }
                    }

                }



                temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')

                temporal = this.Order(temporal, 'ItemCode', true)


                for (const item of temporal) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }


                await this.setState({ Body: temporal, BodyFilter: temporal, Totals: this.getTotals(temporal), AllNoProccessInformation: result.data, CheckFilters: filters, CheckFiltersSeller: filtersSeller })
            }
        } else {
            confirmCloseAlert('incorrect', 'Both dates must be established\n to make the report!')
        }
        this.ModalLoading.current.showState(false);
    }

    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

    searchShorts = e => {

        let search = e.target.value;

        let orders = this.state.Body.filter((item) => {
            if (((
                this.contains(item.ItemCode, search) ||
                this.contains(item.ProductLine, search) ||
                this.contains(item.ItemCodeDesc, search)

            ))
            ) {
                return item
            } else {
                return null
            }
        });
        this.setState({ BodyFilter: orders, Totals: this.getTotals(orders), SearchText: search });

    }

    // Raw (per-invoice) rows that match the same Route + Seller + text filters currently
    // applied to the on-screen table (BodyFilter) — used to build the "Shorts Detail"
    // export sheet so the download matches what's actually visible, not the full dataset.
    getFilteredDetailRows() {
        const search = this.state.SearchText
        return this.state.AllNoProccessInformation.filter((item) => {
            const index = getIndexElement(this.state.CheckFilters, 'Route', item.UDF_RUTA)
            const indexSeller = getIndexElement(this.state.CheckFiltersSeller, 'Seller', String(item.Seller === null || item.Seller === undefined ? '' : item.Seller))
            if (index === -1 || indexSeller === -1) return false
            if (!this.state.CheckFilters[index].check || !this.state.CheckFiltersSeller[indexSeller].check) return false

            if (search) {
                return this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLineDesc, search) ||
                    this.contains(item.ItemCodeDesc, search)
            }
            return true
        })
    }

    getTotals(temporal) {
        let totals = []
        let flag = true
        let count = 0
        for (const item of temporal) {
            for (const detail of item.Detail) {
                for (let a = 0; a < detail.Months.length; a++) {
                    if (flag) {
                        totals.push(detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts))
                        totals.push('$')
                        totals.push(detail.Months[a].SalesPrice === '-' ? 0 : Number(detail.Months[a].SalesPrice))
                        //totals.push('$')
                        //totals.push(detail.Months[a].PurchaseCost === '-' ? 0 : Number(detail.Months[a].PurchaseCost))
                    } else {
                        totals[count] += detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts)
                        count += 2
                        totals[count] += detail.Months[a].SalesPrice === '-' ? 0 : Number(detail.Months[a].SalesPrice)
                        //count += 2
                        //totals[count] += detail.Months[a].PurchaseCost === '-' ? 0 : Number(detail.Months[a].PurchaseCost)
                        count += 1
                    }

                }
            }
            flag = false
            count = 0
        }
        for (let num = 0; num < totals.length; num++) {
            if (totals[num] !== '$') {
                totals[num] = NumberFormat(pricesFormat(totals[num]))
            }
        }

        return totals
    }

    Order(arreglo, llave, bandera) {

        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }

    handleModalOpen = (modal) => {
        var temporal = this.state[modal]
        temporal = true
        this.setState({ [modal]: temporal })
    }

    handleModalClose = (modal) => {
        var temporal = this.state[modal]
        temporal = false
        this.setState({ [modal]: temporal })
    }
    clearOnlyShortDetail() {
        this.setState({
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: '',
                totalShorts: 0,
                totalQuantityShipped: 0,
                totalQuantityOrdered: 0,
                totalShort: 0
            },
            ShortDetail: [],
        })
    }

    // ── Shorts by Product Line (bar chart) ──────────────────────────────────
    async getShortsByProductLine(data) {
        this.setState({ ProductLineChartLoading: true, ProductLineChartError: null })
        try {
            const result = await getInformationWithDataDashboard('/invoice/report/shorts-chart', data)
            if (result && result.status && result.status.code === 1) {
                this.setState({ ShortsByProductLine: result.data || [], ProductLineChartLoading: false })
            } else {
                this.setState({ ProductLineChartError: 'Can not get data from the API. ', ProductLineChartLoading: false })
            }
        } catch (e) {
            this.setState({ ProductLineChartError: 'Can not get data from the API. ', ProductLineChartLoading: false })
        }
    }

    getProductLineChartData() {
        const rows = this.state.ShortsByProductLine
        return {
            labels: rows.map((r) => r.ProductLine),
            datasets: [{
                label: 'Short Value',
                data: rows.map((r) => Number(r.ShortValue) || 0),
                backgroundColor: rows.map((r, i) => PRODUCT_LINE_COLORS[i % PRODUCT_LINE_COLORS.length])
            }]
        }
    }

    getProductLineChartOptions() {
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                title: { display: true, text: 'Shorts by Product Line ($)' },
                tooltip: {
                    callbacks: {
                        label: (context) => '$' + NumberFormat(pricesFormat(context.parsed.y))
                    }
                }
            },
            scales: {
                y: {
                    ticks: {
                        callback: (value) => '$' + NumberFormat(Number(value).toFixed(0))
                    }
                }
            }
        }
    }

    // Bar click → the /shorts-chart-product-line endpoint only returns a single
    // aggregate {ProductLine, ShortValue} row (no item-level detail), so instead of
    // hitting it we reuse the already-loaded ItemsByProductLine (same data backing the
    // "Items by Product Line" table below) and filter it client-side for this line.
    handleProductLineChartClick = (event) => {
        const chart = this.ProductLineChartRef.current
        if (!chart) return
        const elements = getElementAtEvent(chart, event)
        if (!elements.length) return
        const index = elements[0].index
        const row = this.state.ShortsByProductLine[index]
        if (!row) return
        this.openProductLineDetail(row.ProductLine)
    }

    openProductLineDetail = (productLine) => {
        const items = this.state.ItemsByProductLine.filter((item) => item.ProductLineDesc === productLine)
        this.setState({
            showProductLineModal: true,
            ProductLineModalTitle: productLine,
            ProductLineModalData: items,
            ProductLineModalLoading: false,
            ProductLineModalError: null
        })
    }

    closeProductLineModal = () => {
        this.setState({
            showProductLineModal: false,
            ProductLineModalTitle: '',
            ProductLineModalData: [],
            ProductLineModalError: null
        })
    }

    // ── Items grouped by Product Line (table) ───────────────────────────────
    async getItemsByProductLine(data) {
        this.setState({ ItemsByProductLineLoading: true, ItemsByProductLineError: null })
        try {
            const result = await getInformationWithDataDashboard('/invoice/report/shorts-by-items', data)
            if (result && result.status && result.status.code === 1) {
                // Highest short value first — Product Line is now its own column, not a
                // grouping key, so sorting is purely by ShortValue descending.
                const items = (result.data || []).slice().sort((a, b) => Number(b.ShortValue) - Number(a.ShortValue))
                this.setState({ ItemsByProductLine: items, ItemsByProductLineLoading: false })
            } else {
                this.setState({ ItemsByProductLineError: 'Can not get data from the API. ', ItemsByProductLineLoading: false })
            }
        } catch (e) {
            this.setState({ ItemsByProductLineError: 'Can not get data from the API. ', ItemsByProductLineLoading: false })
        }
    }

    async DetailofShort(itemCode) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentItem
        temporal.ItemCode = itemCode.ItemCode
        temporal.ItemCodeDesc = itemCode.ItemCodeDesc
        temporal.ProductLine = itemCode.ProductLine

        let SpecificDetail = []
        var total = 0
        var totalShipped = 0
        var totalOrdered = 0
        var totalShorts = 0
        for (const item of this.state.AllNoProccessInformation) {
            const index = getIndexElement(this.state.CheckFilters, 'Route', item.UDF_RUTA)
            const indexSeller = getIndexElement(this.state.CheckFiltersSeller, 'Seller', String(item.Seller === null  ||  item.Seller === undefined ?  '' : item.Seller))
            if (index !== -1 && indexSeller !== -1) {
                if (item.ItemCode === itemCode.ItemCode && this.state.CheckFilters[index].check && this.state.CheckFiltersSeller[indexSeller].check) {
                    total += Number(item.UnitPrice) * Number(item.shorts)
                    totalShipped += Number(item.QuantityShipped)
                    totalOrdered += Number(item.QuantityOrdered)
                    totalShorts += Number(item.shorts)
                    item.TotalShort = Number(item.UnitPrice) * Number(item.shorts)
                    item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                    item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                    item.TotalShortD = '$' + pricesFormat(Number(item.UnitPrice) * Number(item.shorts))
                    SpecificDetail.push(item)
                }
            }


        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        temporal.totalShort = totalShorts
        SpecificDetail.push()

        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            ItemCode: itemCode.ItemCode
        }
        const resultImg = await getInformationWithData('/Items/get/Img', data)

        if (resultImg.status.code === 1) {
            if (resultImg.data.itemURLImage) {
                if (resultImg.data.itemURLImage !== '') {
                    const date = new Date().getTime()
                    temporal.itemURL = `${resultImg.data.itemURLImage}`
                } else {
                    temporal.itemURL = ''
                }
            } else {
                temporal.itemURL = ''
            }
        }

        await this.setState({ ShortDetail: SpecificDetail, currentItem: temporal })
        var totalRow = {
            InvoiceDate: 'TOTAL',
            QuantityShipped: totalShipped,
            QuantityOrdered: totalOrdered,
            shorts: totalShorts,
            TotalShortD: '$' + pricesFormat(total)
        }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async OrderPriceMargins(option, pos) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "Item Code":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Product Line":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Short":
                let t1 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilter: t1, flag: !this.state.flag })
                break;
            case "Short ($)":
                let t2 = await this.orderShorts(temporal, pos, "SalesPrice")
                await this.setState({ BodyFilter: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async orderShorts(array, conditions, key) {

        const l = array.length

        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {

                const pos1 = await getIndexElement(array[j].Detail, 'year', conditions.year)
                const pos2 = await getIndexElement(array[j].Detail[pos1].Months, 'month', conditions.month)
                const pos3 = await getIndexElement(array[j + 1].Detail, 'year', conditions.year)
                const pos4 = await getIndexElement(array[j + 1].Detail[pos3].Months, 'month', conditions.month)
                const m = array[j].Detail[pos1].Months[pos2][key] === '-' ? 0 : Number(array[j].Detail[pos1].Months[pos2][key])
                const n = array[j + 1].Detail[pos3].Months[pos4][key] === '-' ? 0 : Number(array[j + 1].Detail[pos3].Months[pos4][key])
                if (this.state.flag) {
                    if (m > n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                } else {
                    if (m < n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                }

            }
        }


        return array
    }

    checkSpecific = async (e, actualStat, Route) => {
        await this.ChangeCheck(actualStat, Route)
        await this.UpdateShortsByFilter()
    }

    ChangeCheck(stat, route) {
        const temporal = this.state.CheckFilters
        const index = getIndexElement(temporal, 'Route', route)

        if (index !== -1) {
            temporal[index].check = !stat
        }
        this.setState({ CheckFilters: temporal })

    }

    checkSpecificSeller = async (e, actualStat, Seller) => {
        await this.ChangeCheckSeller(actualStat, Seller)
        await this.UpdateShortsByFilter()
    }

    ChangeCheckSeller(stat, seller) {
        const temporal = this.state.CheckFiltersSeller
        const index = getIndexElement(temporal, 'Seller', seller)

        if (index !== -1) {
            temporal[index].check = !stat
        }
        this.setState({ CheckFiltersSeller: temporal })

    }


    async UpdateShortsByFilter() {
        this.ModalLoading.current.showState(true);
        let temporal = []
        for (const item of this.state.AllNoProccessInformation) {

            const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
            const indexFilter = getIndexElement(this.state.CheckFilters, 'Route', item.UDF_RUTA)
            const indexFilterSeller = getIndexElement(this.state.CheckFiltersSeller, 'Seller', String(item.Seller === null  ||  item.Seller === undefined ?  '' : item.Seller))

            if (indexFilter !== -1 && indexFilterSeller !== -1) {
                if (this.state.CheckFilters[indexFilter].check && this.state.CheckFiltersSeller[indexFilterSeller].check) {
                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []

                    if (index === -1 && splitDate.length === 3) {

                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: Number(item.shorts),
                            SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                            PurchaseCost: Number(item.UnitCost),
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: Number(item.shorts),
                                SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                                PurchaseCost: Number(item.UnitCost),
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: Number(item.shorts),
                                    SalesPrice: Number(item.UnitPrice) * Number(item.shorts),
                                    PurchaseCost: Number(item.UnitCost),
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS 
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += Number(item.shorts)
                                element3.SalesPrice += (Number(item.UnitPrice) * Number(item.shorts))
                                element3.PurchaseCost += Number(item.UnitCost)
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }

                    }
                }
            }


        }

        for (const month of this.state.HeaderTable.Row2) {
            for (const item of temporal) {
                const indexyear = getIndexElement(item.Detail, 'year', month.year)
                if (indexyear === -1) {
                    const add = {
                        year: month.year,
                        Months: [{
                            PurchaseCost: '-',
                            SalesPrice: '-',
                            dolar: "$",
                            month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                            shorts: '-',
                        }]
                    }
                    item.Detail.push(add)
                } else {
                    const temporal = item.Detail[indexyear]
                    const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                    if (indexmonth === -1) {
                        const add2 = {
                            PurchaseCost: '-',
                            SalesPrice: '-',
                            dolar: "$",
                            month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                            shorts: '-',
                        }
                        temporal.Months.push(add2)
                        item.Detail[indexyear] = temporal
                    }
                }
            }

        }



        temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')

        temporal = this.Order(temporal, 'ItemCode', true)


        for (const item of temporal) {
            for (const detail of item.Detail) {
                detail.Months = this.Order(detail.Months, 'month', true)
            }
            item.Detail = this.Order(item.Detail, 'year', true)
        }


        // Re-apply the active text search on top of the Route/Seller filter, otherwise
        // toggling a pill silently drops whatever the user had typed in the search box.
        const search = this.state.SearchText
        const filteredTemporal = search
            ? temporal.filter((item) =>
                this.contains(item.ItemCode, search) ||
                this.contains(item.ProductLine, search) ||
                this.contains(item.ItemCodeDesc, search)
            )
            : temporal

        await this.setState({ Body: temporal, BodyFilter: filteredTemporal, Totals: this.getTotals(filteredTemporal) })

        this.ModalLoading.current.showState(false);
    }


    getShortsKPIs() {
        const data = this.state.AllNoProccessInformation;
        if (!data.length) return null;
        const totalShortUnits = data.reduce((s, r) => s + Number(r.shorts), 0);
        const totalShortValue = data.reduce((s, r) => s + (Number(r.UnitPrice) * Number(r.shorts)), 0);
        const uniqueItems     = new Set(data.map(r => r.ItemCode)).size;
        const routes          = this.state.CheckFilters.filter(f => f.check).length;
        return { totalShortUnits, totalShortValue, uniqueItems, routes };
    }

    render() {
        const hasData = this.state.Body.length > 0;
        const kpis = hasData ? this.getShortsKPIs() : null;

        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
        const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' };

        return (
            <div className="dash-page" style={{ }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{  marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineBarChart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Shorts Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Items ordered but not fully shipped within the selected date range</p>
                    </div>
                    {hasData && (
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.BodyFilter.length.toLocaleString('en-US')} items
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Controls */}
                    <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Date Range</span>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="startShortFilterDate">Start Date</label>
                                    <input style={inputStyle} id="startShortFilterDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="endShortFilterDate">End Date</label>
                                    <input style={inputStyle} id="endShortFilterDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button onClick={() => this.getShorts()} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center' }}>
                                        <AiOutlineReload /> Load Data
                                    </button>
                                </div>
                                {hasData && (
                                    <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                        <ExcelDocument
                                            archname={'Shorts ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                            sheetname2={['Shorts Detail ' + getValueCookie('Company')]}
                                            sheetname={'Shorts ' + getValueCookie('Company')}
                                            data={getDataSetShorts(this.state.HeaderTable.Row1, this.state.HeaderTable.Row2, this.state.HeaderTable.Row3, this.state.BodyFilter, this.state.Totals)}
                                            data2={[getDataSet(this.getFilteredDetailRows(), ['Item Code', 'Product Line', 'Description', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Month', 'Quantity Ordered', 'Quantity Shipped', 'Shorts', 'Unit Cost ($)', 'Unit Price ($)'], ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'Month', 'QuantityOrdered', 'QuantityShipped', 'shorts', 'UnitCost', 'UnitPrice'])]}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* KPIs */}
                    {hasData && kpis && (
                        <div className="row g-3 mb-3">
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-danger">
                                    <div className="metric-label">Short Units</div>
                                    <div className="metric-value">{Math.round(kpis.totalShortUnits).toLocaleString('en-US')}</div>
                                    <div className="metric-change">Total undelivered</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-warning">
                                    <div className="metric-label">Short Value</div>
                                    <div className="metric-value">${NumberFormat(pricesFormat(kpis.totalShortValue))}</div>
                                    <div className="metric-change">At list price</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Unique Items</div>
                                    <div className="metric-value">{kpis.uniqueItems.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Distinct SKUs</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-success">
                                    <div className="metric-label">Active Routes</div>
                                    <div className="metric-value">{kpis.routes}</div>
                                    <div className="metric-change">Filters applied</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Table card */}
                    {hasData && (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                        <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Route</span>
                                        {/* Route filter pills */}
                                        {this.state.CheckFilters.map((element, e) => (
                                            <label key={e} htmlFor={"flexCheckShorts" + element.Route}
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', padding: '0.25rem 0.7rem', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer', userSelect: 'none', background: element.check ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)', color: element.check ? 'white' : 'rgba(255,255,255,0.5)', border: `1px solid ${element.check ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.15)'}` }}>
                                                <input type="checkbox" id={"flexCheckShorts" + element.Route}
                                                    checked={element.check} style={{ display: 'none' }}
                                                    onChange={(ev) => this.checkSpecific(ev, element.check, element.Route)}
                                                />
                                                {element.Route}
                                            </label>
                                        ))}
                                    </div>
                                    <div style={{ position: 'relative', minWidth: '240px' }}>
                                        <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input type="text" autoComplete="off"
                                        placeholder="Search item code, line, description…"
                                        onChange={this.searchShorts}
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                    </div>
                                </div>

                                {this.state.CheckFiltersSeller.length > 0 &&
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                        <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Seller</span>
                                        {/* Seller filter pills */}
                                        {this.state.CheckFiltersSeller.map((element, e) => (
                                            <label key={e} htmlFor={"flexCheckShortsSeller" + element.Seller}
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', padding: '0.25rem 0.7rem', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer', userSelect: 'none', background: element.check ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)', color: element.check ? 'white' : 'rgba(255,255,255,0.5)', border: `1px solid ${element.check ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.15)'}` }}>
                                                <input type="checkbox" id={"flexCheckShortsSeller" + element.Seller}
                                                    checked={element.check} style={{ display: 'none' }}
                                                    onChange={(ev) => this.checkSpecificSeller(ev, element.check, element.Seller)}
                                                />
                                                {element.Seller || '(No Seller)'}
                                            </label>
                                        ))}
                                    </div>
                                }
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        {/* Row 1 — Year */}
                                        <tr>
                                            {this.state.HeaderTable.Row1.map((col, i) => (
                                                <th key={i} colSpan={col.span} className="text-center"
                                                    style={{ background: i % 2 === 0 ? 'linear-gradient(135deg,#0f172a,#1e3a8a)' : '#1e3a8a', color: 'white', fontWeight: 800, fontSize: '0.8rem', letterSpacing: '0.04em', padding: '6px 8px', border: 'none' }}>
                                                    {col.year}
                                                </th>
                                            ))}
                                        </tr>
                                        {/* Row 2 — Month */}
                                        <tr>
                                            <th colSpan={4} style={{ background: '#1e293b', border: 'none', padding: '5px' }}></th>
                                            {this.state.HeaderTable.Row2.map((col, i) => (
                                                <th key={i} colSpan={3} className="text-center"
                                                    style={{ background: i % 2 === 0 ? '#1e293b' : '#334155', color: 'rgba(255,255,255,0.85)', fontWeight: 700, fontSize: '0.75rem', padding: '5px 8px', border: 'none' }}>
                                                    {col.month}
                                                </th>
                                            ))}
                                        </tr>
                                        {/* Row 3 — Column names */}
                                        <tr>
                                            {this.state.HeaderTable.Row3.map((col, c) => (
                                                col.title.map((tit, t) => (
                                                    <th key={t} onClick={() => this.OrderPriceMargins(tit, col)}
                                                        className="text-center"
                                                        style={{ cursor: tit ? 'pointer' : 'default', whiteSpace: 'nowrap' }}>
                                                        {tit}
                                                        {tit !== '' && <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>}
                                                    </th>
                                                ))
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((element, e) => (
                                            <tr onClick={() => this.DetailofShort(element)} key={uuidv4()} style={{ cursor: 'pointer' }}>
                                                <td className="text-center">{e + 1}</td>
                                                <td className="text-center">{element.ItemCode}</td>
                                                <td className="text-center">{element.ProductLine}</td>
                                                <td>{element.ItemCodeDesc}</td>
                                                {element.Detail.map((year) => (
                                                    year.Months.map((month) => (
                                                        month.shorts === '-' ? (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">0</td>
                                                                <td className="text-end">$</td>
                                                                <td className="text-end">0</td>
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">{month.shorts}</td>
                                                                <td className="text-end">{month.dolar}</td>
                                                                <td className="text-end">{NumberFormat(pricesFormat(month.SalesPrice))}</td>
                                                            </React.Fragment>
                                                        )
                                                    ))
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td></td><td></td><td></td><td>TOTALS</td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className={t === 0 ? 'text-center' : 'text-end'} key={t}>{total}</td>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Shorts by Product Line — bar chart */}
                    {hasData && (
                        <div className="card mt-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Shorts by Product Line</span>
                            </div>
                            <div className="card-body">
                                {this.state.ProductLineChartLoading ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0', margin: 0 }}>Loading…</p>
                                ) : this.state.ProductLineChartError ? (
                                    <p style={{ textAlign: 'center', color: '#EF4444', padding: '2rem 0', margin: 0 }}>{this.state.ProductLineChartError}</p>
                                ) : this.state.ShortsByProductLine.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0', margin: 0 }}>No shorts data by product line for this date range.</p>
                                ) : (
                                    <div style={{ overflowX: 'auto' }}>
                                        <div style={{ height: '360px', minWidth: Math.max(this.state.ShortsByProductLine.length * 70, 280) + 'px' }}>
                                            <Bar
                                                ref={this.ProductLineChartRef}
                                                options={this.getProductLineChartOptions()}
                                                data={this.getProductLineChartData()}
                                                onClick={this.handleProductLineChartClick}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Items by Product Line — table */}
                    {hasData && (
                        <div className="card mt-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Items by Product Line</span>
                            </div>
                            <div className="card-body">
                                {this.state.ItemsByProductLineLoading ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0', margin: 0 }}>Loading…</p>
                                ) : this.state.ItemsByProductLineError ? (
                                    <p style={{ textAlign: 'center', color: '#EF4444', padding: '2rem 0', margin: 0 }}>{this.state.ItemsByProductLineError}</p>
                                ) : this.state.ItemsByProductLine.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0', margin: 0 }}>No items to show for this date range.</p>
                                ) : (
                                    <div className="tableFixHeadSmall">
                                        <table className="table table-clean mb-0">
                                            <thead>
                                                <tr className="text-center">
                                                    <th>Item Code</th>
                                                    <th>Description</th>
                                                    <th>Product Line</th>
                                                    <th className="text-end">Short Qty</th>
                                                    <th className="text-end">Short Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ItemsByProductLine.map((item, i) => (
                                                    <tr key={item.ItemCode || i}>
                                                        <td className="text-center">{item.ItemCode}</td>
                                                        <td className="text-start">{item.ItemCodeDesc}</td>
                                                        <td className="text-start">{item.ProductLineDesc}</td>
                                                        <td className="text-end">{NumberFormat(pricesFormat(item.ShortQty))}</td>
                                                        <td className="text-end">${NumberFormat(pricesFormat(item.ShortValue))}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {!hasData && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', opacity: 0.3, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                        </div>
                    )}
                </div>

                {/* Detail modal */}
                <ModalOrders
                    title={'Shorts of Item: ' + this.state.currentItem.ItemCode}
                    show={this.state.showModal1}
                    close={(modal = "showModal1") => this.handleModalClose(modal)}
                >
                    <div>
                        <div className="row mb-3 align-items-center">
                            <div className="col-sm-4 text-center">
                                <img key={this.state.currentItem.itemURL}
                                    style={{ maxHeight: '140px', objectFit: 'contain' }}
                                    src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'}
                                    alt="ProductImg" />
                            </div>
                            <div className="col-sm-5 d-flex flex-column gap-2 justify-content-center">
                                <div>
                                    <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700, marginRight: '0.5rem' }}>{this.state.currentItem.ItemCode}</span>
                                    <span style={{ background: 'rgba(139,92,246,0.08)', color: '#5b21b6', border: '1px solid #DDD6FE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700 }}>{this.state.currentItem.ProductLine}</span>
                                </div>
                                <p style={{ color: '#334155', fontWeight: 600, margin: 0 }}>{this.state.currentItem.ItemCodeDesc}</p>
                            </div>
                            <div className="col-sm-3 d-flex align-items-center justify-content-end">
                                <ExcelDocument
                                    archname={'Shorts Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                    sheetname={'Shorts Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                    data={getDataSet(this.state.ShortDetailWithTotal, ['Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Shorts', 'Unit Cost', 'Unit Price', 'Total Short($)'], ['InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'shorts', 'UnitCostD', 'UnitPriceD', 'TotalShortD'])}
                                />
                            </div>
                        </div>
                        <div className="tableFixHeadSmall">
                            <table className="table table-clean mb-0">
                                <thead>
                                    <tr className="text-center">
                                        <th>Invoice No</th><th>Customer No</th><th>Customer Name</th>
                                        <th>Price Level</th><th>Salesperson</th><th>Route</th><th>Date</th>
                                        <th>Qty Ordered</th><th>Qty Shipped</th><th>Shorts</th>
                                        <th></th><th>Unit Cost</th><th></th><th>Unit Price</th><th></th><th>Total Short($)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ShortDetail.map((item, i) => (
                                        <tr key={i}>
                                            <td className="text-center">{item.InvoiceNo}</td>
                                            <td className="text-center">{item.CustomerNo}</td>
                                            <td>{item.BillToName}</td>
                                            <td className="text-center">{item.PriceLevel}</td>
                                            <td className="text-center">{item.SalespersonNo}</td>
                                            <td>{item.UDF_RUTA}</td>
                                            <td className="text-center">{new Date(item.InvoiceDate).toLocaleDateString()}</td>
                                            <td className="text-center">{NumberFormat(item.QuantityOrdered)}</td>
                                            <td className="text-center">{NumberFormat(item.QuantityShipped)}</td>
                                            <td className="text-center">{NumberFormat(item.shorts)}</td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(item.UnitCost))}</td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(item.TotalShort))}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="tfoot">
                                    <tr>
                                        <td>TOTAL</td><td colSpan={6}></td>
                                        <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityOrdered))}</td>
                                        <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityShipped))}</td>
                                        <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalShort))}</td>
                                        <td colSpan={4}></td>
                                        <td className="text-end">$</td>
                                        <td className="text-end">{NumberFormat(pricesFormat(this.state.currentItem.totalShorts))}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </ModalOrders>

                {/* Product Line detail modal (opened from the bar chart) */}
                <ModalOrders
                    title={'Shorts of Product Line: ' + this.state.ProductLineModalTitle}
                    show={this.state.showProductLineModal}
                    close={() => this.closeProductLineModal()}
                >
                    <div className="tableFixHeadSmall">
                        {this.state.ProductLineModalLoading ? (
                            <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0' }}>Loading…</p>
                        ) : this.state.ProductLineModalError ? (
                            <p style={{ textAlign: 'center', color: '#EF4444', padding: '2rem 0' }}>{this.state.ProductLineModalError}</p>
                        ) : this.state.ProductLineModalData.length === 0 ? (
                            <p style={{ textAlign: 'center', color: '#94A3B8', padding: '2rem 0' }}>No items to show for this product line.</p>
                        ) : (
                            <table className="table table-clean mb-0">
                                <thead>
                                    <tr className="text-center">
                                        <th>Item Code</th>
                                        <th>Description</th>
                                        <th className="text-end">Short Qty</th>
                                        <th className="text-end">Short Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ProductLineModalData.map((item, i) => (
                                        <tr key={item.ItemCode || i}>
                                            <td className="text-center">{item.ItemCode}</td>
                                            <td className="text-start">{item.ItemCodeDesc}</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(item.ShortQty))}</td>
                                            <td className="text-end">${NumberFormat(pricesFormat(item.ShortValue))}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="tfoot">
                                    <tr>
                                        <td colSpan={2} className="fw-bold">TOTAL</td>
                                        <td className="text-end fw-bold">
                                            {NumberFormat(pricesFormat(this.state.ProductLineModalData.reduce((s, item) => s + Number(item.ShortQty), 0)))}
                                        </td>
                                        <td className="text-end fw-bold">
                                            ${NumberFormat(pricesFormat(this.state.ProductLineModalData.reduce((s, item) => s + Number(item.ShortValue), 0)))}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        )}
                    </div>
                </ModalOrders>
            </div>
        )
    }

}
